<div *ngIf="showToast" class="toast">
  <div class="inline-message" [ngClass]="type">
    <mat-icon class="inline-message-icon" [color]="type">
      {{ icon }}
    </mat-icon>
    <div class="inline-message-content">
      <div class="title">{{ title }}</div>
      <div class="description">{{ description }}</div>
      <div class="note" *ngIf="note">{{ note }}</div>
    </div>
    <mat-icon (click)="onClose()" class="inline-message-close-icon" [color]="type">
      close
    </mat-icon>
  </div>
</div>